// extracted by mini-css-extract-plugin
export var fullGrid = "_2m-3";
export var pdpPreviewContainer = "_2m-1";
export var previewContainer = "_2m-0";
export var togglePreviewContainer = "_2m-2";